/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Payload to create a new claim.
 * @export
 * @interface CreateClaimRequest
 */
export interface CreateClaimRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateClaimRequest
     */
    claimNumber: string;
    /**
     * 
     * @type {string}
     * @memberof CreateClaimRequest
     */
    policyNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClaimRequest
     */
    insuredName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateClaimRequest
     */
    insuredPhone?: string | null;
    /**
     * Secondary phone number for the insured
     * @type {string}
     * @memberof CreateClaimRequest
     */
    insuredPhone2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClaimRequest
     */
    insuredEmail?: string | null;
    /**
     * Secondary email address for the insured
     * @type {string}
     * @memberof CreateClaimRequest
     */
    insuredEmail2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClaimRequest
     */
    dateOfLoss?: string | null;
    /**
     * Type of loss (free text)
     * @type {string}
     * @memberof CreateClaimRequest
     */
    lossType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClaimRequest
     */
    propertyAddress?: string | null;
    /**
     * Mailing address if different from property address
     * @type {string}
     * @memberof CreateClaimRequest
     */
    mailingAddress?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateClaimRequest
     */
    propertySquareFootage?: number | null;
    /**
     * Insurance company name
     * @type {string}
     * @memberof CreateClaimRequest
     */
    insuranceCarrier?: string | null;
    /**
     * Internal file number for company tracking
     * @type {string}
     * @memberof CreateClaimRequest
     */
    internalFileNumber?: string | null;
    /**
     * Name or company of the referring contractor (e.g. the operator who referred this claim).
     * @type {string}
     * @memberof CreateClaimRequest
     */
    contractor?: string | null;
    /**
     * ID of the folder to assign this claim to. Optional - if omitted, the claim is unfiled.
     * @type {number}
     * @memberof CreateClaimRequest
     */
    claimFolderId?: number | null;
    /**
     * ID of the pipeline to assign this claim to. Optional - if omitted, the company's default pipeline is used. The claim starts at that pipeline's first status unless claimStatusTemplateId is also provided.
     * @type {number}
     * @memberof CreateClaimRequest
     */
    pipelineId?: number;
    /**
     * ID of the status template. Optional - if omitted, the company's template with the lowest display_order will be auto-assigned. Every company is guaranteed to have at least one template.
     * @type {number}
     * @memberof CreateClaimRequest
     */
    claimStatusTemplateId?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateClaimRequest
     */
    description?: string | null;
}

/**
 * Check if a given object implements the CreateClaimRequest interface.
 */
export function instanceOfCreateClaimRequest(value: object): value is CreateClaimRequest {
    if (!('claimNumber' in value) || value['claimNumber'] === undefined) return false;
    if (!('insuredName' in value) || value['insuredName'] === undefined) return false;
    return true;
}

export function CreateClaimRequestFromJSON(json: any): CreateClaimRequest {
    return CreateClaimRequestFromJSONTyped(json, false);
}

export function CreateClaimRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateClaimRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'claimNumber': json['claimNumber'],
        'policyNumber': json['policyNumber'] == null ? undefined : json['policyNumber'],
        'insuredName': json['insuredName'],
        'insuredPhone': json['insuredPhone'] == null ? undefined : json['insuredPhone'],
        'insuredPhone2': json['insuredPhone2'] == null ? undefined : json['insuredPhone2'],
        'insuredEmail': json['insuredEmail'] == null ? undefined : json['insuredEmail'],
        'insuredEmail2': json['insuredEmail2'] == null ? undefined : json['insuredEmail2'],
        'dateOfLoss': json['dateOfLoss'] == null ? undefined : json['dateOfLoss'],
        'lossType': json['lossType'] == null ? undefined : json['lossType'],
        'propertyAddress': json['propertyAddress'] == null ? undefined : json['propertyAddress'],
        'mailingAddress': json['mailingAddress'] == null ? undefined : json['mailingAddress'],
        'propertySquareFootage': json['propertySquareFootage'] == null ? undefined : json['propertySquareFootage'],
        'insuranceCarrier': json['insuranceCarrier'] == null ? undefined : json['insuranceCarrier'],
        'internalFileNumber': json['internalFileNumber'] == null ? undefined : json['internalFileNumber'],
        'contractor': json['contractor'] == null ? undefined : json['contractor'],
        'claimFolderId': json['claimFolderId'] == null ? undefined : json['claimFolderId'],
        'pipelineId': json['pipelineId'] == null ? undefined : json['pipelineId'],
        'claimStatusTemplateId': json['claimStatusTemplateId'] == null ? undefined : json['claimStatusTemplateId'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function CreateClaimRequestToJSON(json: any): CreateClaimRequest {
    return CreateClaimRequestToJSONTyped(json, false);
}

export function CreateClaimRequestToJSONTyped(value?: CreateClaimRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claimNumber': value['claimNumber'],
        'policyNumber': value['policyNumber'],
        'insuredName': value['insuredName'],
        'insuredPhone': value['insuredPhone'],
        'insuredPhone2': value['insuredPhone2'],
        'insuredEmail': value['insuredEmail'],
        'insuredEmail2': value['insuredEmail2'],
        'dateOfLoss': value['dateOfLoss'],
        'lossType': value['lossType'],
        'propertyAddress': value['propertyAddress'],
        'mailingAddress': value['mailingAddress'],
        'propertySquareFootage': value['propertySquareFootage'],
        'insuranceCarrier': value['insuranceCarrier'],
        'internalFileNumber': value['internalFileNumber'],
        'contractor': value['contractor'],
        'claimFolderId': value['claimFolderId'],
        'pipelineId': value['pipelineId'],
        'claimStatusTemplateId': value['claimStatusTemplateId'],
        'description': value['description'],
    };
}

